import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "dept-picker-body"
};
const _hoisted_2 = {
  class: "dept-search"
};
const _hoisted_3 = {
  class: "dept-tree-panel"
};
const _hoisted_4 = {
  class: "dept-node"
};
const _hoisted_5 = {
  class: "dept-node-label"
};
const _hoisted_6 = {
  class: "dept-picker-footer"
};
const _hoisted_7 = {
  class: "dept-footer-info"
};
const _hoisted_8 = {
  class: "dept-footer-actions"
};
import { ref, computed, watch } from 'vue';
import { Search } from '@element-plus/icons-vue';
import { getDeptTree } from '@/api/dept';
export default {
  __name: 'DeptPicker',
  props: {
    modelValue: {
      type: [Array, String, Number],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const dialogVisible = ref(false);
    const loading = ref(false);
    const searchKeyword = ref('');
    const deptTree = ref([]);
    const treeRef = ref();
    const expandedKeys = ref([]);
    const selectedIds = computed(() => {
      if (!props.modelValue) return [];
      const arr = Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue];
      return arr.filter(item => item != null).map(item => typeof item === 'object' ? item.id : item);
    });
    const loadDeptTree = async () => {
      try {
        loading.value = true;
        const res = await getDeptTree();
        const processTree = nodes => {
          return nodes.map(node => ({
            ...node,
            leaf: !node.children || node.children.length === 0,
            children: node.children ? processTree(node.children) : []
          }));
        };
        deptTree.value = processTree(res || []);
        expandedKeys.value = deptTree.value.map(d => d.id);
      } catch (error) {
        console.error('加载部门树失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const filterNode = (value, nodeData) => {
      if (!value) return true;
      return nodeData.name?.includes(value) || false;
    };
    const handleSearch = () => {
      if (treeRef.value) {
        treeRef.value.filter(searchKeyword.value);
      }
    };
    const handleReset = () => {
      searchKeyword.value = '';
      handleSearch();
    };
    const handleCheck = () => {
      if (treeRef.value) {
        const checkedNodes = treeRef.value.getCheckedNodes();
        const values = checkedNodes.map(node => ({
          id: node.id,
          name: node.name
        }));
        emit('update:modelValue', props.multiple ? values : values[0] || null);
      }
    };
    const handleConfirm = () => {
      if (treeRef.value) {
        const checkedNodes = treeRef.value.getCheckedNodes();
        const values = checkedNodes.map(node => ({
          id: node.id,
          name: node.name
        }));
        emit('update:modelValue', props.multiple ? values : values[0] || null);
      }
      dialogVisible.value = false;
    };
    watch(dialogVisible, val => {
      if (val) {
        loadDeptTree();
      }
    });
    const open = () => {
      dialogVisible.value = true;
    };
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        "modal-class": "dept-picker-overlay",
        title: __props.multiple ? `选择部门（已选 ${selectedIds.value.length}）` : '选择部门',
        width: "460px",
        class: "dept-picker-dialog",
        "append-to-body": "",
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_cache[4] || (_cache[4] = _createTextVNode(" 已选择 ", -1)), _createElementVNode("em", null, _toDisplayString(selectedIds.value.length), 1), _cache[5] || (_cache[5] = _createTextVNode(" 个部门 ", -1))]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          onClick: handleConfirm
        }, "确定")])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: searchKeyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
          class: "dept-search-input",
          placeholder: "搜索部门名称",
          clearable: "",
          onKeyup: _withKeys(handleSearch, ["enter"]),
          onClear: handleSearch
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(Search))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("button", {
          type: "button",
          class: "dept-search-button is-primary",
          onClick: handleSearch
        }, "搜索"), _createElementVNode("button", {
          type: "button",
          class: "dept-search-button",
          onClick: handleReset
        }, "重置")]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [deptTree.value.length > 0 ? (_openBlock(), _createBlock(_component_el_tree, {
          key: 0,
          ref_key: "treeRef",
          ref: treeRef,
          class: "dept-tree",
          data: deptTree.value,
          props: {
            label: 'name',
            children: 'children',
            isLeaf: 'leaf'
          },
          "default-expanded-keys": expandedKeys.value,
          "node-key": "id",
          "show-checkbox": "",
          "default-checked-keys": selectedIds.value,
          "filter-node-method": filterNode,
          onCheck: handleCheck
        }, {
          default: _withCtx(({
            node
          }) => [_createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("span", {
            class: "dept-node-icon",
            "aria-hidden": "true"
          }, [_createElementVNode("svg", {
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [_createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 00-2 0v1H8a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1V9z",
            "clip-rule": "evenodd"
          })])], -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(node.label), 1)])]),
          _: 1
        }, 8, ["data", "default-expanded-keys", "default-checked-keys"])) : !loading.value ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "暂无部门数据",
          "image-size": 64
        })) : _createCommentVNode("", true)])), [[_directive_loading, loading.value]])])]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};